module.exports = __webpack_public_path__ + "fonts/nunito-sans-v8-latin-regular.890d934b.woff";